import { rhybusRListsHttp } from '../api/rhybus-list-http'
import { ListNames } from '../config/configuration'

export type SecurityGroupMetadataItem = {
    eKey: string
    eTag: string
    SecurityGroupTitle: string
    Description: string
}

export const fetchSecurityGroupMetadata = async (): Promise<SecurityGroupMetadataItem[]> => {
    try {
        const items = [...(await (await rhybusRListsHttp().getList(ListNames.DSCA_SECURITY_GROUP_METADATA)).query().get<any>())]
        return items.map((item: any) => ({
            eKey: item?.eKey ?? item?.ID ?? '',
            eTag: item?.eTag ?? '',
            SecurityGroupTitle: item?.SecurityGroupTitle ?? '',
            Description: item?.Description ?? '',
        })).filter((item) => item.SecurityGroupTitle)
    } catch (error) {
        console.error('Error fetching security group metadata:', error)
        return []
    }
}

export type UserInfo = {
    Id?: number
    Title: string
    Email: string
    LoginName: string
    [key: string]: unknown
}

export type RoleGroup = {
    role: string
    roleUsers: UserInfo[]
    is_active: string
}

export type AddPeopleState = {
    userKey: string
    userEmail: string
}

export type PersonData = {
    email: string
    DisplayText: string
    persona?: string
    spKey?: string
}

export type UserManagementFilterConfig = {
    id: string
    label?: string
    placeholder?: string
    options: string[]
    value: string
    onChange: (value: string) => void
    onClear?: () => void
    className?: string
}

export type UserManagementConfig = {
    addPopup?: {
        showCurrentRoles?: boolean
        showAvailableRoles?: boolean
        showRemoveButton?: boolean
        searchUserLabel?: string
        currentRolesLabel?: string
        availableRolesLabel?: string
        addButtonLabel?: string
        cancelButtonLabel?: string
    }
    table?: {
        columns?: Record<string, string>
        showDeleteButton?: boolean
        showAccordion?: boolean
        accordionColumns?: Record<string, string>
    }
}